module.exports = __webpack_public_path__ + "img/AKA at MissEgyp 1997.dc903975.png";